<div *ngIf="ready"
     [ngModelGroup]="groupName"
     class="fieldsetsContainer">
  <div class="fieldsetsGroup">
    <datex-common-form-field-shell *ngIf="valueType == valueTypeBoolean"
                                   label="Boolean value">
      <input *ngIf="readOnly"
             [ngModel]="scalarValueGet()"
             [readonly]="true"
             class="datex-textbox readonly"
             name="type" />
      <mat-select *ngIf="!readOnly"
                  [ngModel]="scalarValueGet()"
                  (ngModelChange)="scalarValueSet($event)"
                  name="json"
                  required
                  class="datex-selectcontainer"
                  disableOptionCentering
                  panelClass="dropdown-below datex-dropdownpanel">
        <mat-option [value]="true"
                    class="datex-dropdownoption">
          true
        </mat-option>
        <mat-option [value]="false"
                    class="datex-dropdownoption">
          false
        </mat-option>
      </mat-select>
    </datex-common-form-field-shell>

    <datex-common-form-field-shell *ngIf="valueType == valueTypeString"
                                   label="String value">
      <input [ngModel]="scalarValueGet()"
             (ngModelChange)="scalarValueSet($event)"
             [ngModelOptions]="{updateOn: 'blur'}"
             [readonly]="readOnly"
             class="datex-textbox {{readOnly ? 'readonly ' : ''}}"
             name="json"
             [required]="!readOnly" />
    </datex-common-form-field-shell>

    <datex-common-form-field-shell *ngIf="valueType === valueTypeNumber"
                                   label="Number value">

      <datex-common-numberbox [ngModel]="scalarValueGet()"
                              (ngModelChange)="scalarValueSet($event)"
                              [readOnly]="readOnly"
                              name="json"
                              [required]="!readOnly"></datex-common-numberbox>
    </datex-common-form-field-shell>

    <datex-common-form-field-shell *ngIf="valueType === valueTypeDate"
                                   label="Date value">

      <datex-common-datebox [ngModel]="scalarValueGet()"
                            (ngModelChange)="scalarValueSet($event)"
                            [readOnly]="readOnly"
                            name="json"
                            [required]="!readOnly"></datex-common-datebox>
    </datex-common-form-field-shell>

    <datex-common-form-field-shell *ngIf="valueType === valueTypeTime"
                                   label="Time value">

      <datex-common-timebox [ngModel]="scalarValueGet()"
                            (ngModelChange)="scalarValueSet($event)"
                            [readOnly]="readOnly"
                            name="json"
                            [required]="!readOnly"></datex-common-timebox>
    </datex-common-form-field-shell>
  </div>
</div>